import React from 'react';

import Paper from '@material-ui/core/Paper/Paper';
import { withStyles, createStyles, WithStyles } from '@material-ui/core/styles';

import Title from '../../Common/Title';
import locales from '../../../locales';
import UserStatisticTableItem
  from '../../Common/Statistic/StatisticTable/UserStatisticTableItem.tsx';

interface Props {
  statistic: {
    total: number;
    totalCancelledByGuest: number;
    totalCancelledByRestaurant: number;
    totalDeclined: number;
    totalClosed: number;
    totalReceiptAmount: number;
    averageReceiptAmount: number;
    commissionAmount: number;
  };
  moneySymbol: string;
}

const styles = createStyles({
  statisticsWrap: {
    display: 'flex',
    flexDirection: 'column',
    padding: 24,
    paddingTop: 16,
    width: '80%',
  },
  statisticRow: {
    display: 'flex',
    justifyContent: 'left',
    paddingBottom: 40,
  },
});

interface IProps extends Props, WithStyles<typeof styles> {}


const index: React.FC<IProps> = ({ statistic, classes, moneySymbol }) => (
  <Paper elevation={3} style={{ height: '100%' }}>
    <Title text={locales.t('sourceStatistic.statisticTable.title')} />
    <div className={classes.statisticsWrap}>
      <div className={classes.statisticRow}>
        <UserStatisticTableItem
          type={locales.t('sourceStatistic.statisticTable.reservesRow.summary')}
          stat={statistic.total || 0}
        />
        <UserStatisticTableItem
          type={locales.t('sourceStatistic.statisticTable.reservesRow.success')}
          stat={statistic.totalClosed || 0}
        />
        <UserStatisticTableItem
          type={locales.t('sourceStatistic.statisticTable.reservesRow.canceledByRestaurant')}
          stat={statistic.totalCancelledByRestaurant || 0}
        />
      </div>
      <div className={classes.statisticRow}>
        <UserStatisticTableItem
          type={locales.t('sourceStatistic.statisticTable.reservesRow.declinedByRestaurant')}
          stat={statistic.totalDeclined || 0}
        />
        <UserStatisticTableItem
          type={locales.t('sourceStatistic.statisticTable.checkRow.average')}
          stat={`${statistic.averageReceiptAmount.toFixed()} ${moneySymbol}`}
          color="primary"
        />
        <UserStatisticTableItem
          type={locales.t('sourceStatistic.statisticTable.reservesRow.canceledByGuest')}
          stat={statistic.totalCancelledByGuest || 0}
        />
      </div>
    </div>
  </Paper>
);

export default withStyles(styles)(index);
